import { render, staticRenderFns } from "./FormularioRegistro.vue?vue&type=template&id=f806ba46&"
import script from "./FormularioRegistro.vue?vue&type=script&lang=js&"
export * from "./FormularioRegistro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports